import React, { useEffect, useRef } from 'react';
import { debounce } from 'lodash-es';
import { useTranslation } from 'next-i18next';

import TitleLink from '../../../components/TitleLink';
import { useScreenSize, BreakPoint } from '../../../components/ScreenSize';

import { useNavAnchor } from '../../../components/NavAnchor';

interface IProps {
  title: string;
  anchor: string;
  hasMore?: boolean;
  linkUrl?: string;
  titleCls?: string;
  children?: React.ReactNode;
  linkOut?: boolean;
}

function InvestorBlock(props: IProps) {
  const { title, titleCls, anchor, hasMore, linkUrl, children, linkOut = false } = props;
  const ref = useRef<HTMLDivElement | null>(null);

  const { t } = useTranslation('investor');
  const { setAnchorTop } = useNavAnchor();
  const { screen } = useScreenSize();
  const screenRef = useRef(screen);

  const setAnchorTopRef = useRef((offsetTop: number) => setAnchorTop(anchor, offsetTop));

  useEffect(() => {
    const resizeHandler = debounce(() => {
      const isMobile = screenRef.current === BreakPoint.lg || BreakPoint.md || BreakPoint.sm;
      const yOffset = isMobile ? 80 : 100;
      const offsetTop = (ref.current?.offsetTop || 0) - yOffset;
      offsetTop && setAnchorTopRef.current(offsetTop);
    });

    resizeHandler();

    window.addEventListener('resize', resizeHandler);

    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, []);

  return (
    <section ref={ref}>
      <a className="scroll-mt-[102px] lg:scroll-mt-[80px]" href="#" id={anchor} aria-label={anchor} />
      <div className="">
        <div className="pb-[20px] pt-[30px] lg:pb-[40px] lg:pt-[68px]">
          <TitleLink
            linkOut={linkOut}
            className={titleCls}
            linkUrl={linkUrl}
            textVal={title}
            linkVal={hasMore ? t('titleSeeAll') : ''}
          />
        </div>
        <div>{children}</div>
      </div>
    </section>
  );
}

export default InvestorBlock;
